import _slicedToArray from "/var/jenkins_home/workspace/web_bieyangapp_review_page/product-search/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect, useRef, useState } from 'react';
export function useRefState(initialState) {
  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var ref = useRef(state);
  useEffect(function () {
    ref.current = state;
  }, [state]);
  return [state, setState, ref];
}